/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useStyles } from '~src/hooks/useStyles';
import { styleFn } from './style';
import { Button, Input } from 'antd';
import { useIntl } from 'react-intl';
import { UploadFilesDropArea } from '../UploadDropZonePannel/UploadFilesDropArea';
import { Fragment, ReactNode, useEffect, useState } from 'react';

const { TextArea } = Input;

export type QuestionFormValues = {
  title: string;
  description: string;
  question: string;
};

export const defaultQuestionFormValues: QuestionFormValues = {
  title: '',
  description: '',
  question: '',
};

type QuestionFormProps = {
  formValues: QuestionFormValues;
  handleValueChange: (key: keyof QuestionFormValues, newValue: unknown) => void;
  withUploadFiles?: boolean;
  titleLabel?: ReactNode;
  descriptionLabel?: ReactNode;
  resetEnabled?: boolean;
};

const QuestionForm: React.FC<QuestionFormProps> = (props) => {
  const {
    formValues,
    handleValueChange,
    titleLabel,
    descriptionLabel,
    withUploadFiles = true,
    resetEnabled = false,
  } = props;

  const intl = useIntl();
  const styles = useStyles(styleFn);

  const [initialValues, setInitialValues] = useState<QuestionFormValues | null>(
    null
  );

  useEffect(() => {
    setInitialValues({ ...formValues });
  }, []);

  const resetQuestion = () => {
    if (initialValues) {
      handleValueChange('question', initialValues.question);
    }
  };

  return (
    <div
      css={styles.formContainer}
      style={{
        // backgroundColor: 'red',
        width: '100%',
        padding: 0,
        margin: '0',
      }}>
      {/*<div css={styles.formItem}>*/}
      {/*  <p css={styles.formLabel}>*/}
      {/*    {intl.formatMessage({ id: 'title' }) || titleLabel}*/}
      {/*  </p>*/}
      {/*  <Input*/}
      {/*    placeholder={intl.formatMessage({ id: 'title' })}*/}
      {/*    value={formValues.title}*/}
      {/*    onChange={(e) => handleValueChange('title', e.target.value)}*/}
      {/*    maxLength={255}*/}
      {/*  />*/}
      {/*</div>*/}
      {/*<div css={styles.formItem}>*/}
      {/*  <p*/}
      {/*    css={styles.formLabel}*/}
      {/*    style={{ fontWeight: 'bold', fontSize: '15px' }}>*/}
      {/*    {descriptionLabel || intl.formatMessage({ id: 'revised-question' })}*/}
      {/*  </p>*/}
      {/*  <TextArea*/}
      {/*    placeholder={intl.formatMessage({ id: 'description' })}*/}
      {/*    value={formValues.description}*/}
      {/*    onChange={(e) => handleValueChange('description', e.target.value)}*/}
      {/*    maxLength={10000}*/}
      {/*    style={{ height: 80 }}*/}
      {/*  />*/}
      {/*</div>*/}
      <div css={styles.formItem}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}>
          <span
            css={styles.formLabel}
            style={{ fontWeight: 'bold', fontSize: '15px' }}>
            {descriptionLabel || intl.formatMessage({ id: 'ask-question' })}
          </span>
          {resetEnabled && (
            <Button type={'dashed'} onClick={resetQuestion}>
              {intl.formatMessage({ id: 'reset' })}
            </Button>
          )}
        </div>
        <TextArea
          placeholder={intl.formatMessage({ id: 'question' })}
          value={formValues.question}
          onChange={(e) => handleValueChange('question', e.target.value)}
          maxLength={10000}
          style={{ height: 80 }}
        />
      </div>
      {/* JIRA: MVP TV-319 */}
      {/*{withUploadFiles && (*/}
      {/*  <Fragment>*/}
      {/*    <p css={styles.formLabel}>*/}
      {/*      {intl.formatMessage({ id: 'type-files' })}*/}
      {/*    </p>*/}
      {/*    <UploadFilesDropArea />*/}
      {/*  </Fragment>*/}
      {/*)}*/}
    </div>
  );
};

export default QuestionForm;
